/** Format an ISO-8601 timestamp as a short, locale-aware date; an unparseable value is shown as given. */
export function formatDate(iso: string): string {
    const date = new Date(iso);
    return Number.isNaN(date.getTime())
        ? iso
        : date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * An instant for the Home feed inspector: UK local time (Europe/London, so BST/GMT as the operator's
 * clock reads) with the UTC time beside it. Question days are UTC calendar days in the feed's deciders,
 * so the UTC boundary stays visible. An unparseable value is shown as given.
 */
export function formatUkAndUtc(iso: string): { uk: string; utc: string } {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return { uk: iso, utc: iso };
    const uk = date.toLocaleString('en-GB', {
        timeZone: 'Europe/London',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
        timeZoneName: 'short',
    });
    const utc = date.toLocaleString('en-GB', {
        timeZone: 'UTC',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
    });
    return { uk, utc: `${utc} UTC` };
}
